import LyAccountStatus from './src/index.vue'

LyAccountStatus.install = function (Vue) {
    Vue.component(LyAccountStatus.name, LyAccountStatus)
}

export default LyAccountStatus



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/account-status/index.js
// module id = null
// module chunks = 